"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const TeamSwitcherMenu = ({ team = {}, onClick = lodash_1.default.noop, }) => {
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: currentRole } = (0, rolesQuery_1.useGetRoleForUserQuery)(currentUser, team.id || '');
    if (!team) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { "data-testid": "sideMenu-team-switch-menu-item", "ts-variant": "sideMenuPanelOption", className: team.selected ? 'is-active' : '', onClick: onClick, children: (0, jsx_runtime_1.jsxs)(material_1.Link, { "ts-variant": "sideMenuSwitcherTeamLink", children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: team.name, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", "ts-variant": "teamName", children: team.name || '' }) }), currentRole && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", "ts-variant": "roleName", children: currentRole.label || '' })), team.selected && (0, jsx_runtime_1.jsx)(Check_1.default, { "ts-variant": "teamSwitcherCheckIcon" })] }) }));
};
exports.default = TeamSwitcherMenu;
